<template>
    <div class="formi983-tab-content">
        <div class="formi983-header">
            <p class="header-content">
                FORM I-983
            </p>
        </div>
        <template v-if="isHRManager">
            <div class="formi983-body">
                <p class="text-style">The 2016 final rule that reinstates the 24-month STEM OPT regulations increases the educational benefits that F-1 students receive from their practical training experiences by requiring the submission of a formal training plan.</p>
                <p class="text-style">The formal training plan must clearly articulate the STEM OPT students learning objectives and affirm the employers commitment to helping the student achieve those objectives. To fulfill this requirement, a student and their employer must complete and sign Form I-983 and submit it to the students DSO.</p>
                <p class="text-style">STEM OPT students and their employers are subject to the terms and conditions of the 24-month STEM OPT extension regulations, the Form I-983 instructions and the completed Form I-983, effective as of the employment start date requested for the associated STEM OPT period, as indicated on the Form I-983. (Source: <a href="https://studyinthestates.dhs.gov/form-i-983-overview" target="_blank">https://studyinthestates.dhs.gov/form-i-983-overview</a>)</p>
                <div class="buttonsblock">
                    <ob-button type="secondary" @click="UploadI983">Upload Physically Signed I-983</ob-button>
                    <ob-button type="primary" @click="InitiateI983">Initiate I-983</ob-button>
                </div>
        </div>
        <initiate-I983-popup :openModal.sync="showInitiatePopup" @initiated="$emit('initiated')"> </initiate-I983-popup>
        <Upload-I983-Popup v-if="showUploadPopup" :openModal.sync="showUploadPopup" @initiated="$emit('initiated')"></Upload-I983-Popup>
        </template>
         <template v-else-if ="IsSupervisor">
            <div style="height: 400px;display:table;width:100%;">
                <div class="pfa-body" style="display: table-cell; vertical-align: middle;text-align: center;">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/no_form.svg`" style="margin-bottom:20px;" /> 
                    <p>Form I-983 is not available for this candidate</p>
                </div>
            </div> 
        </template>
        <template v-else>
            <div style="height: 400px;display:table;width:100%;">
                <div class="pfa-body" style="display: table-cell; vertical-align: middle;text-align: center;">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/Folder_icon.svg`" style="margin-bottom:20px;" /> 
                    <p>Once the employer initiates the Form I-983,</p>
                    <p>Student Information (section 1 & 2) and Training Plan (section-5) will be reflected here.</p>
                </div>
            </div> 
        </template>
    </div>
  
</template>

<script>
    import InitiateI983Popup from './InitiateI983Popup.vue'
     import UploadI983Popup from './UploadI983Popup.vue'
    export default {
        data() {
            return {
                composeMailPopup : false,
                showInitiatePopup: false,
                showUploadPopup:false,
            }
        },
          components: {
             "initiate-I983-popup": InitiateI983Popup,
             "Upload-I983-Popup": UploadI983Popup,
        },
        computed: {
            EmployeeId() {
                return this.$parent.EmployeeId;
            },
            StudentName() {
                return this.$parent.StudentName;
            },
            IsFinalEvaluationDone() {
                return this.$parent.IsFinalEvaluationDone;
            },
            IsSupervisor()
            {
                if(this.$parent.TraineeEmployeeId)
                return true
                else
                return false
            }
        },
        created() 
        {
             
        },
        methods:{
            InitiateI983()
            {
                this.showInitiatePopup = true

            },
            InitiateEmployer()
            {
                this.employerPop = true
            },
            UploadI983()
            {
                this.showUploadPopup = true
            }


        }
    }
</script>

<style lang="scss" scoped>
    .formi983-tab-content {
            position: relative;
			padding: 0 15px;
			display: inline-block;
			width: 100%;
			min-height: 350px;
    }
   .header-content
   {
    font-weight: 600;
    color: #333;
    font-size: 15px;
    padding-top: 2px;
   }
   .formi983-body
   {
    margin-top: 60px;
    text-align: center;
   }
   .formi983-header
   {
    padding: 0 0 20px 0;
    border-bottom: 1px dashed #ccc;
    margin: 10px 0;
   }
   .buttonsblock
   {
    text-align: center;
    padding-top: 23px;
   }
    .text-style{
        font-size: 13px;
        text-align: justify;
        line-height: 20px;
    }
   
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/FormI983Intro.vue